<template>
    <select v-model="status" @change="updateStatus" class="form-control">
        <option v-for="option in options" v-bind:value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>

<script>
    export default {
        props: ['item'],

        data() {
            return {
                status: null,
                options: [
                    { text: '', value: null },
                    { text: Lang.get('messages.order.participated'), value: 'participated' },
                    { text: Lang.get('messages.order.not_participated'), value: 'not_participated' },
                    { text: Lang.get('messages.order.maybe'), value: 'maybe' },
                    { text: Lang.get('messages.order.billed'), value: 'billed' },
                    { text: Lang.get('messages.order.payed'), value: 'payed' },
                    { text: Lang.get('messages.order.no'), value: '-' },
                    { text: Lang.get('messages.order.accounted'), value: 'accounted' },
                ]
            }
        },

        methods: {
            updateStatus() {
                axios.patch('/admin/orders/items/' + this.item.id + '/manager', { status_manager: this.status })
                    .then(response => {
                        if (this.status === 'billed' && (this.item.status_institution != null && this.item.status_institution !== 'participated')) {
                            flash(Lang.get('messages.orderStatusForManager.warning'), 'warning');
                        } else {
                            flash(Lang.get('messages.orderStatusForManager.success'));
                        }
                    })
                    .catch(errors => {
                        console.log(errors.response.data);
                        flash(Lang.get('messages.orderStatusForManager.error'), 'danger')
                    });
            }
        },

        created() {
            this.status = this.item.status_manager;
        }
    }
</script>
